/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateBillingWalletData
 */
export interface UpdateBillingWalletData {
    /**
     * 
     * @type {number}
     * @memberof UpdateBillingWalletData
     */
    billingProductPriceId?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateBillingWalletData
     */
    status?: UpdateBillingWalletDataStatusEnum;
}

/**
* @export
* @enum {string}
*/
export enum UpdateBillingWalletDataStatusEnum {
    Active = 'Active',
    Arrears = 'Arrears',
    Paused = 'Paused',
    Suspended = 'Suspended'
}


/**
 * Check if a given object implements the UpdateBillingWalletData interface.
 */
export function instanceOfUpdateBillingWalletData(value: object): value is UpdateBillingWalletData {
    return true;
}

export function UpdateBillingWalletDataFromJSON(json: any): UpdateBillingWalletData {
    return UpdateBillingWalletDataFromJSONTyped(json, false);
}

export function UpdateBillingWalletDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateBillingWalletData {
    if (json == null) {
        return json;
    }
    return {
        
        'billingProductPriceId': json['billingProductPriceId'] == null ? undefined : json['billingProductPriceId'],
        'status': json['status'] == null ? undefined : json['status'],
    };
}

  export function UpdateBillingWalletDataToJSON(json: any): UpdateBillingWalletData {
      return UpdateBillingWalletDataToJSONTyped(json, false);
  }

  export function UpdateBillingWalletDataToJSONTyped(value?: UpdateBillingWalletData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'billingProductPriceId': value['billingProductPriceId'],
        'status': value['status'],
    };
}

